module.exports = __webpack_public_path__ + "img/upperBody.6f4aaec0.svg";